/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2023 Nevware21
 * Licensed under the MIT license.
 */
export var STR_PROMISE = "Promise";
//# sourceMappingURL=constants.js.map